import { ComponentProps, useMemo } from 'react'
import styled from 'styled-components'

import {
  Column,
  Media as MediaLMF,
  timingSlower,
  untilMd,
  zIndexForeground,
} from '@syconium/little-miss-figgy'
import { fromMd, useScrollDirection } from '@syconium/little-miss-figgy'

export const LoadingSpacer = styled.div`
  height: 200vh;
`

export const Section = styled.section`
  padding: 0px;
  margin-bottom: 40px;

  ${fromMd} {
    padding: 0px 40px;
  }
`
export const FilterColumn = styled(Column)`
  ${untilMd} {
    background: white;
    position: sticky;
    top: 0;
    z-index: ${zIndexForeground};
    padding: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;
  }
`

export const DesktopFilterColumn = styled(Column)``

export const CountColumn = styled(Column)`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: auto;
`

export const FilterBarWrap = styled.div`
  background: white;
  margin: 0 -40px;
  padding: 0 40px;
`

export const FilterBarMedia = styled((props: ComponentProps<typeof MediaLMF>) => {
  const scrollDirection = useScrollDirection()
  const style = useMemo(() => {
    if (scrollDirection !== 'up') return {}
    return {
      top: '60px',
    }
  }, [scrollDirection])
  return <MediaLMF {...props} style={style} />
})`
  position: sticky;
  top: 0px;
  transition: top ${timingSlower};
  z-index: 199;
`

export const TilesPanelColumn = styled(Column)`
  padding-right: 0px;
  box-sizing: content-box;
`
